export const propRules = {
  rules: {
    heading: "Règles de l'hébergement",
    subheading:
      "Définissez les heures d'arrivée et de départ qui seront communiquées au client lors du check-in.",
    cloneTitleNoun: "horaires",
    cloneItemNoun: "les horaires",
    bulkNoticePrefix:
      "Ce changement s'appliquera aux {count} hébergements liés à",
    checkinLabel: "Arrivée",
    checkoutLabel: "Départ",
    defaultCheckin: "Par défaut 15:00",
    defaultCheckout: "Par défaut 12:00",
    saving: "Enregistrement…",
    save: "Enregistrer",
    toasts: {
      loadError: "Impossible de charger les données de l'annonce.",
      bulkApplied: "Règles appliquées à {count} hébergements",
      saveSuccess: "Règles enregistrées avec succès",
      bulkPartialError: "Certains hébergements n'ont pas pu être mis à jour",
      saveError: "Erreur lors de l'enregistrement des règles",
    },
  },
  services: {
    cloneTitleNoun: "équipements et commodités",
    cloneItemNoun: "les équipements et commodités",
    toasts: {
      saveSuccess: "Équipements enregistrés avec succès",
      saveError: "Erreur lors de l'enregistrement des équipements",
    },
  },
  maintenance: {
    title: "Maintenance de l'hébergement",
    scopeProperty: "Hébergement entier",
    scopeUnits: "Unités spécifiques",
    selectUnits: "Sélectionner des unités",
    dateFrom: "Du",
    dateTo: "Au",
    closeArrivals: "Fermer les arrivées (CTA)",
    closeDepartures: "Fermer les départs (CTD)",
    applying: "Application...",
    apply: "Appliquer la maintenance",
    removing: "Suppression...",
    remove: "Supprimer la maintenance",
    toasts: {
      rangeScopeRequired:
        "Complétez la plage de dates et la portée (unités ou hébergement).",
      applied: "Maintenance appliquée.",
      applyError: "Erreur lors de l'application de la maintenance.",
      removed: "Maintenance supprimée.",
      removeError: "Erreur lors de la suppression de la maintenance.",
    },
  },
  propMaintenance: {
    title: "Maintenance de l'hébergement",
    scopeProperty: "Hébergement entier",
    scopeUnits: "Unités spécifiques",
    selectUnits: "Sélectionner des unités",
    dateFrom: "Du",
    dateTo: "Au",
    closeArrivals: "Fermer les arrivées (CTA)",
    closeDepartures: "Fermer les départs (CTD)",
    applying: "Application...",
    apply: "Appliquer la maintenance",
    removing: "Suppression...",
    remove: "Supprimer la maintenance",
    toasts: {
      rangeScopeRequired:
        "Complétez la plage de dates et la portée (unités ou hébergement).",
      applied: "Maintenance appliquée.",
      applyError: "Erreur lors de l'application de la maintenance.",
      removed: "Maintenance supprimée.",
      removeError: "Erreur lors de la suppression de la maintenance.",
    },
  },
};
